<template>
  <div class="PageChange">
    <!-- <Page :total="pageInfo.totalPages" :current="pageInfo.pageNumber"  show-elevator @on-change="pageChange"></Page> -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="pageChange"
      :current-page.sync="pageInfo.pageNumber"
      :page-size="pageInfo.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageInfo.totalPages"
      v-if="pageInfo.totalPages != 0"
    >
    </el-pagination>
    <!-- <div class="showPage">
      <span>共{{ Math.ceil(pageInfo.totalPages / 10)}}页,</span>
      <span>共{{pageInfo.totalPages}}条数据</span>
    </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      pageshow: true,
    };
  },
  props: {
    pageInfo: {
      type: Object,
      required: true,
    },
  },
  name: "PageChange",
  watch: {
    $route(to, from) {
      console.log(11111, this.$route.path);
    },
  },
  methods: {
    handleSizeChange(val) {
      console.log(val);
      this.pageInfo.pageSize = val;
      localStorage.setItem("pageSize", this.pageInfo.pageSize);
      this.pageInfo.pageFunc(this.pageInfo.pageNumber, this.pageInfo.pageSize);
    },
    pageChange(currentPage) {
      console.log(currentPage);
      this.pageInfo.pageNumber = currentPage;
      window.localStorage.setItem("pageNumber", this.pageInfo.pageNumber);
      this.pageInfo.pageFunc(this.pageInfo.pageNumber, this.pageInfo.pageSize);
    },
  },
  mounted() {
    let a = localStorage.getItem("pageSize");
    let currentPage = localStorage.getItem("pageNumber");
    if (currentPage != null) {
      this.pageInfo.pageNumber = Number(currentPage);
    }
    if (a) {
      this.pageInfo.pageSize = Number(a);
      this.pageInfo.pageFunc(this.pageInfo.pageNumber, this.pageInfo.pageSize);
    }
  },
  // beforeUpdate() {
  //   localStorage.setItem("pageNumber", Number(this.pageInfo.pageNumber));
  // },
  // beforeDestroy() {
  //   // localStorage.setItem("pageNumber", 1);
  // }
};
</script>

<style lang="stylus">
.PageChange {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 20px 0 0;

  .showPage {
    span {
      margin-left: 10px;
    }
  }
}
</style>
